import { styled } from '@mui/material';

import { IconButtonGhostMini } from '../IconButtonGhostMini';
import { Tooltip } from '../Tooltip';
import { infoButtonClasses } from './theme';
import {
  ARROW_TO_PLACEMENT_MAP,
  type InfoButtonOwnerState,
  type InfoButtonWithTooltipProps,
} from './types';

const InfoButtonWithTooltip = (props: InfoButtonWithTooltipProps) => {
  const { tooltipProps, arrow = 'down', children, inverse, color = 'default', ...others } = props;

  const ownerState: InfoButtonOwnerState = {
    ...props,
    alertType: 'tooltip',
    arrow,
    color,
  };

  const { message } = tooltipProps;

  const placement = ARROW_TO_PLACEMENT_MAP[arrow];
  const tooltipColor = inverse ? 'inverse' : 'default';

  if (!message) return null;

  return (
    <Tooltip color={tooltipColor} {...tooltipProps} placement={placement} arrow={true}>
      <InfoButtonIcon ownerState={ownerState} {...others}>
        {children}
      </InfoButtonIcon>
    </Tooltip>
  );
};

export default InfoButtonWithTooltip;

const InfoButtonIcon = styled(IconButtonGhostMini, {
  target: infoButtonClasses.icon,
})<{ ownerState: InfoButtonOwnerState }>`
  & svg {
    color: ${({ ownerState, theme }) => {
      if (ownerState.color === 'red') return theme.color['icon/danger/default'];
      if (ownerState.color === 'yellow') return theme.color['icon/warning/default'];
      return theme.color['icon/weaker/default'];
    }};
  }
`;
